import { ConnectorConfig } from '../../../models';
import { IsNotEmpty, IsString, Matches } from 'class-validator';

export class ConnectorConfigStrapi extends ConnectorConfig {
	@IsString()
	@IsNotEmpty()
	@Matches(/^[A-Za-z0-9_-]+$/, { message: 'target must be a Strapi collection API ID' })
	target: string;
}
